// extracted by mini-css-extract-plugin
module.exports = {"app_card":"our-app-card_app_card__EzEyJ","title":"our-app-card_title__c_0ad","href":"our-app-card_href__8mKCY"};